import { CountryDto } from '../CountryDto';
import { AgentDto } from '../agent/AgentDto';
import { FilingTypeDto } from '../FilingTypeDto';

export interface FeeSheetRuleDto {
  FeeSheetRuleId: Guid,
  FeeSheetRowId: Guid,
  CountryId?: number,
  CurrencyId?: number,
  TargetAmount?: number,
  CapAmount?: number,
  Notes: string,
  DeletedDate?: Date,
  Level: FeeSheetRuleLevelEnum,
  Type: string,
  Amount: number,
  CountryCode?: string,
  Country?: CountryDto,
  Agent?: AgentDto,
  ClientId?: Guid,
  FilingTypes: FilingTypeDto[],  
  PhaseTypeId?: number,
  Signed: boolean,
  InJurisdiction: boolean,
  EffectiveDate?: Date
}

export enum FeeSheetRuleLevelEnum {
  NA = 0,
  Level1= 1,
  Level2 = 2,
  Level3 = 3,
  Level4 = 4,
  Level5 = 5,
  Level6 = 6,
  Level7 = 7,  
  Level8 = 8,
  Level9 = 9,
  Level10 = 10,
}

export enum FeeSheetRuleLevelNameEnum {
  NA = "N/A",
  Level1 = "Level 1",
  Level2 = "Level 2",
  Level3 = "Level 3",
  Level4 = "Level 4",
  Level5 = "Level 5",
  Level6 = "Level 6",
  Level7 = "Level 7",  
  Level8 = "Level 8",
  Level9 = "Level 9",
  Level10 = "Level 10",
}

export enum FeeSheetRuleTypeEnum {
  Cap = "Cap",
  Target = "Target"
}

export function FeeSheetRulesSortFunction(rule1: FeeSheetRuleDto, rule2: FeeSheetRuleDto) : number {
  let result = 0;

  if(rule1.CountryId == null || rule2.CountryId == null) {
    if(rule1.CountryId == null && rule2.CountryId != null) {
        result = -1;
    }
    else if(rule1.CountryId != null && rule2.CountryId == null) {
        result = 1;
    }
  }
  else {
    if(rule1.CountryId < rule2.CountryId) {
        result = -1;
    }
    else if(rule1.CountryId > rule2.CountryId) {
        result = 1;
    }
  }

  if(result == 0) {
    if(rule1.Level < rule2.Level) {
        result = -1;
    }
    else if(rule1.Level > rule2.Level) {
        result = 1;
    }
  }

  if(result == 0) {
    if(rule1.TargetAmount != null && rule2.CapAmount != null) {
      result = -1;
    }
    else if(rule1.CapAmount != null && rule2.TargetAmount != null) {
      result = 1;
    }
  }
  
  return result;
}